import React from 'react'
import CatalogDisplaysMapMethods, {
    ICatalogDisplaysMapItem,
    ICatalogDisplaysMapProps,
} from './catalog__map_displays.local.methods'
import styles from './catalog__map_displays.jcss'
import { withRouter } from 'react-router'
import { MapCreator } from 'features/map/controllers/MapCreator'
import { OpenStreetMap } from '../../../../features/map/molecules/OpenStreetMap/OpenStreetMap-view'
import { OpenStreetMapMarker } from '../../../../features/map/molecules/OpenStreetMap/OpenStreetMap-types'
import { TMapPoint } from '../../../../features/map/models/map'
import { MAP_CENTER, MAP_ZOOM } from 'features/map/constants'
import { useTypedAuthenticatedSelector } from 'core/store/hooks'
const mapFactory = MapCreator.getInstance().getMapFactory()
const CreatedMap = mapFactory.createMap()
const mapApi = mapFactory.createMapApi()

const CatalogDisplaysMap = (p_: ICatalogDisplaysMapProps) => {
    const userLocation = useTypedAuthenticatedSelector((state) => {
        const user = state.user.data as typeof state.user.data & { location?: TMapPoint }
        return user.location ?? null
    })
    const { onChange } = CatalogDisplaysMapMethods(p_, userLocation)

    const markerClick = (item: ICatalogDisplaysMapItem) => {
        p_.onSelectCluster([item])
        p_.onSelectInfoByItem(item)
    }

    const openStreetMapMarkerClick = (marker: OpenStreetMapMarker) => {
        const item = p_.list.find(({ id }) => id === marker.id)

        if (item) {
            markerClick(item)
        }
    }

    const clusterClick = (list: ICatalogDisplaysMapItem[]) => {
        p_.onSelectCluster(list)
    }

    const onMapChange = (center: TMapPoint, distance: number) => {
        onChange(center, distance)
        p_.centerMap(center)
    }

    const center = p_.center || userLocation || MAP_CENTER

    return (
        <div className={styles.map}>
            {window.spconfig.map.type === 'open-street-map' ? (
                <OpenStreetMap
                    onClose={() => {}}
                    isOpen={true}
                    location={center}
                    onChangeLocation={() => {}}
                    onChangePlacemarkGeometry={() => {}}
                    markers={p_.list}
                    onMarkerClick={openStreetMapMarkerClick}
                    onChange={onMapChange}
                />
            ) : (
                <CreatedMap
                    onMarkerClick={markerClick}
                    onClusterClick={clusterClick}
                    onChange={onMapChange}
                    markers={p_.list}
                    activeMarkerList={p_.selectedItems}
                    activeMarker={p_.selectedInfo ?? null}
                    zoom={p_.zoom ?? MAP_ZOOM}
                    markerColor={p_.markerColor}
                    activeMarkerColor={p_.activeMarkerColor}
                    center={center}
                    mapApi={mapApi}
                />
            )}
        </div>
    )
}
export default withRouter(CatalogDisplaysMap)
